import { KrCard } from '@/common/card/KrCard';
import { useNavStateSync } from '@/common/hooks/navState/useNavStateSync';
import { Box, ToggleButton, ToggleButtonGroup } from '@mui/material';
import { ChbkFinTrendTable } from './ChbkFinTrendTable';

export const ChbkFinTrendTableCard = ({ formValues, totalValues, ctrtTypeIdToCtrtType }) => {
  const [byYear, setByYear] = useNavStateSync('chbkFinTrendByYear', false);
  const [dim, setDim] = useNavStateSync('chbkFinTrendDim', 'PROD');

  const formatPeriodicity = (periodicity) => {
    switch (periodicity) {
      case 'DAY':
        return 'Daily';
      case 'MONTH':
        return 'Monthly';
      case 'QUARTER':
        return 'Quarterly';
      default:
        return '';
    }
  };

  const trendButtons = (
    <Box
      sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center', gap: 2, mb: 2 }}
    >
      <ToggleButtonGroup
        exclusive
        size="small"
        value={dim}
        sx={{ width: 'fit-content' }}
        onChange={(event, value) => {
          if (value !== null) setDim(value);
        }}
      >
        <ToggleButton value={'PROD'} aria-label="bold">
          Product
        </ToggleButton>
        <ToggleButton value={'DIST_CUST'} aria-label="bold">
          Distributor
        </ToggleButton>
        <ToggleButton value={'CTRT'} aria-label="bold">
          Contract
        </ToggleButton>
      </ToggleButtonGroup>
      {formValues?.periodicity !== 'DAY' && (
        <ToggleButtonGroup
          exclusive
          size="small"
          value={byYear}
          sx={{ width: 'fit-content' }}
          onChange={(event, value) => {
            if (value !== null) setByYear(value);
          }}
        >
          <ToggleButton value={false} aria-label="bold">
            Period
          </ToggleButton>
          <ToggleButton value={true} aria-label="bold">
            YoY
          </ToggleButton>
        </ToggleButtonGroup>
      )}
    </Box>
  );

  return (
    <KrCard title={`${formatPeriodicity(formValues?.periodicity)} Paid Trends`} buttons={trendButtons}>
      <ChbkFinTrendTable
        formValues={formValues}
        totalValues={totalValues}
        ctrtTypeIdToCtrtType={ctrtTypeIdToCtrtType}
        byYear={formValues?.periodicity === 'DAY' ? false : byYear}
        dim={dim}
      />
    </KrCard>
  );
};
